import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { WorkbooksDisplayGridRowDataFragmentGql } from './WorkbooksDisplayGridRowDataFragmentGql';

export const VirtualConnectionTableDownstreamWorkbooksQueryGql: DocumentNode = gql`
query VirtualConnectionTableDownstreamWorkbooksQuery(
  $vizportalUrlId: String!,
  $first: Int!,
  $offset:
  Int!,
  $orderBy: WorkbookSortOrder!
) {
  virtualConnectionTables(filter: { vizportalUrlId: $vizportalUrlId }) {
    downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...WorkbooksDisplayGridRowDataFragment
      }
    }
  }
}
${WorkbooksDisplayGridRowDataFragmentGql}
`;
